import React from 'react';
import PropTypes from 'prop-types';
import s from '../PointsTableWrapper/PointsTableWrapper.scss';
import Listingheader from '../../../../home/components/common/ListingheaderV2';
import InterSectionBorder from '../../../../../components_v2/common/InterSectionBorder/InterSectionBorder';
import GenericTable from '../../../../../components_v2/common/GenericTable/GenericTable';

const ContentTable = props => {
  const {
    path,
    className = ' ',
    borderbottom,
    bordertop,
    border,
    items = [],
    name,
  } =
    props.sectionItem || {};

  // If there is no data, return a fallback message.
  if (!items || items.length === 0) {
    return <p>No data available</p>;
  }

  return (
    <>
      {!!bordertop && <InterSectionBorder />}
      <div
        className={`${s.section_wrapper} ${className} ${
          border === 'top' && props.isWapView ? s.mobile_border : ''
        }`}
      >
        {/* Render the header */}
        <Listingheader
          headingname={name}
          headingLink={!props.isWapView ? path : null}
        />
        <div className={s.tableContentWrap}>
          <GenericTable
            columns={[
              { label: 'S.No.', key: 'sno' },
              { label: 'Date/Day', key: 'date' },
              {
                label: 'Name of Festival',
                key: 'name',
              },
            ]}
            data={items || []}
            // headerTitle="Holiday List"
            ga4Type="table_view"
            tableClass="custom-table"
            fixedFirstColumn
            firstColumnDark
          />
        </div>
        {/* Render the table if items exist */}
      </div>

      {/* Render border if specified */}
      {!!borderbottom && <InterSectionBorder />}
    </>
  );
};
ContentTable.propTypes = {
  sectionItem: PropTypes.objectOf({}),
  isWapView: PropTypes.bool,
};
ContentTable.defaultProps = {
  sectionItem: {},
  isWapView: false,
};
export default React.memo(ContentTable);
